import styled from 'styled-components';

export const BaseDiv = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ContentDiv = styled.div`
  flex: 1;
`;